import styled from "styled-components";
import { Colors } from "../../theme/styled";
import customMedia from "../../config/breakpoints";

export const StyledButton = styled.a<{ color?: string }>`
  align-items: center;
  background: ${({ theme, color }) =>
    color ? theme.colors[color as keyof Colors] : theme.colors.blueDark};
  border: 0;
  border-radius: 4px;
  box-sizing: border-box;
  color: ${({ theme }) => theme.colors.white};
  cursor: pointer;
  display: flex;
  justify-content: center;
  font-family: Aileron;
  padding: 20px 72px;
  transition: all 0.3s ease;
  width: 100%;

  ${customMedia.lessThan("mobile")`
    padding: 20px;
`}

  &:hover {
    border: 1px ${({ theme }) => theme.colors.blueDarker};
    background: ${({ theme }) => theme.colors.blueDarker};
  }
`;
